import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

const rangeMap: Record<string, Record<string, string>> = {
  total: {
    '0': '0',
    '1': '0-9',
    '2': '9-14',
    '3': '15+',
  },
  consumer: {
    '0': '0',
    '1': '0-1',
    '2': '1-2',
    '3': '2-4',
    '4': '4+',
  },
  online: {
    '0': '0',
    '1': '0-1',
    '2': '1-5',
    '3': '5-11',
    '4': '11+',
  },
}

const decode = (value: string, type: keyof typeof rangeMap) => rangeMap[type][value] ?? '—'

const Field = ({ label, value }: { label: string; value?: string }) => (
  <div className="flex flex-col gap-1">
    <Text size="xs" c="dimmed">
      {label}
    </Text>
    <Text size="sm" className="text-gray-700" fw={500}>
      {value || '—'}
    </Text>
  </div>
)

export default function LendingInstitution({ data }: { data: any }) {
  const theme = useTheme()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        借贷机构类型与规模
      </Text>
      <Stack gap="sm" className="mt-3">
        <div className="grid gap-3 md:grid-cols-2">
          <Field label="贷款总机构数" value={decode(data?.loan_info_xyp_cpl0001, 'total')} />
          <Field label="消费金融类机构数" value={decode(data?.loan_info_xyp_cpl0007, 'consumer')} />
          <Field label="网络贷款类机构数" value={decode(data?.loan_info_xyp_cpl0008, 'online')} />
        </div>
      </Stack>
    </div>
  )
}
